var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconGroceries128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2623 37.0161L42.262 23.8855H56.96L61.9598 37.0161C62.8188 39.2723 63.2592 41.6662 63.2592 44.0803V65.2435H35.9629V44.0803C35.9629 41.6662 36.4032 39.2723 37.2623 37.0161Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6779 15.6138H40.544C39.1735 15.6138 38.0625 16.7248 38.0625 18.0953V21.4039C38.0625 22.7744 39.1735 23.8854 40.544 23.8854H58.6779C60.0484 23.8854 61.1594 22.7744 61.1594 21.4039V18.0953C61.1594 16.7248 60.0484 15.6138 58.6779 15.6138Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8912 34.5381C60.6348 33.248 63.1619 32.41 65.7492 33.0559C67.4418 33.4785 69.1601 35.3368 70.7016 35.3368C72.48 35.3368 74.4493 33.457 76.3569 33.0849C78.9819 32.5728 81.4903 33.6649 83.2243 35.0945C86.9612 38.1754 88.6472 44.2336 87.9012 49.3327C86.7818 56.9843 82.7139 62.9284 76.4606 65.165C74.2859 65.4074 73.5177 65.043 72.8053 64.6843L72.6036 64.5833C72.1312 64.3502 71.6275 64.145 70.7016 64.145C68.2299 64.145 68.7768 65.6274 64.8276 65.1228C58.6387 62.8542 54.6144 56.9365 53.502 49.3327C52.7097 43.9172 54.7462 37.6047 58.8912 34.5381Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7517 25.5398C72.8148 25.5398 70.5415 27.8234 70.5415 33.6207",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6913 58.1932L64.6626 61.1075L67.5942 58.1731L72.9261 52.8359L81.3057 61.1075L89.8182 52.8359L97.8707 61.1075L98 114.873H31V61.1075L39.375 52.8359L47.7408 61.1075L56.2293 52.8359L61.6913 58.1932Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconGroceries128);
export default __webpack_public_path__ + "static/media/pictogramBeaconGroceries128.60875d68710cedd57dc166b784df3f3f.svg";
export { ForwardRef as ReactComponent };